/**
 * Live countdown fragment for content-change status overlay (hard-coded PT like CurrentState).
 * Clamps to at least ~1s while still waiting so the cue never shows "~0s".
 */

export function formatContentChangeEtaRemaining(
  etaAtMs: number | null | undefined,
  nowMs: number
): string | null {
  if (etaAtMs == null || !Number.isFinite(etaAtMs) || !Number.isFinite(nowMs)) {
    return null
  }
  const remainMs = Math.max(0, etaAtMs - nowMs)
  const sec = Math.max(1, Math.ceil(remainMs / 1000))
  if (sec >= 60) {
    const minutes = Math.ceil(sec / 60)
    return `~${minutes}m`
  }
  return `~${sec}s`
}
